<template>
  <section id="hero">
    <v-parallax dark src="@/assets/img/bgHero.jpg" height="750">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center" class="text-start">
            <v-col cols="12" md="6" xl="8">
              <h1 class="display-2 font-weight-bold mb-4">Certificação de Hardware</h1>
              <h1 class="font-weight-light">
                Qualidade e segurança para seu dispositivo.
              </h1>
              <div class="d-none video d-none align-center py-4">
                <a @click.stop="dialog = true" class="playBut">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/" x="0px" y="0px" width="60px" height="60px"
                    viewBox="0 0 213.7 213.7" enable-background="new 0 0 213.7 213.7" xml:space="preserve">
                    <polygon class="triangle" id="XMLID_18_" fill="none" stroke-width="7" stroke-linecap="round"
                      stroke-linejoin="round" stroke-miterlimit="10" points="73.5,62.5 148.5,105.8 73.5,149.1 " />

                    <circle class="circle" id="XMLID_17_" fill="none" stroke-width="7" stroke-linecap="round"
                      stroke-linejoin="round" stroke-miterlimit="10" cx="106.8" cy="106.8" r="103.3" />
                  </svg>
                </a>
                <p class="subheading ml-2 mb-0">Video Informativo</p>
              </div>
            </v-col>
            <v-col cols="12" md="6" xl="4" class="hidden-sm-and-down"> </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="svg-border-waves text-white">
        <v-img src="@/assets/img/borderWaves.svg" />
      </div>
    </v-parallax>
    <v-container fluid id="features" class="mt-4">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="space-around">
            <v-col cols="12" class="text-center">
              <img src="~@/assets/img/hcl-certified.png" width="150px" height="150px" class="mb-3" alt="">
              <h1 class="font-weight-light display-2">Certificações</h1>
              <h1 class="font-weight-light">
                Explore nossos dispositivos certificados:
              </h1>

              <v-row align="center" justify="center">
                <v-col cols="12" sm="10" md="8" lg="6">
                  <v-card class="mt-12 mb-12">
                    <v-toolbar flat>
                      <v-text-field v-model="searchTerm" label="Busque modelos certificados" min-width="500"
                        hide-details="auto" @keypress.enter="searchModels"></v-text-field>
                      <v-btn icon @click="searchModels">
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="4" class="text-center" v-for="(feature, i) in features" :key="i">
              <router-link :to="`/certificados/${feature.slug}`">

                <v-hover v-slot:default="{ hover }">
                  <v-card class="card" shaped :elevation="hover ? 10 : 4" :class="{ up: hover }">
                    <v-img :src="feature.img" max-width="100px" class="d-block ml-auto mr-auto"
                      :class="{ 'zoom-efect': hover }"></v-img>
                    <h1 class="font-weight-regular">{{ feature.title }}</h1>
                  </v-card>
                </v-hover>
              </router-link>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog" max-width="640px">
      <v-card>
        <youtube :video-id="videoId" @ready="ready" @playing="playing"></youtube>
      </v-card>
    </v-dialog>
    <div class="svg-border-waves">
      <img src="~@/assets/img/wave2.svg" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      dialog: false,
      searchTerm: "",
      rules: [],
      videoId: "ZJK_Z4Ff5M0",
      features: [
        {
          img: require("@/assets/img/desktop.png"),
          title: "Desktops",
          slug: "desktop"
        },
        {
          img: require("@/assets/img/laptop.png"),
          title: "Laptops",
          slug: "laptop"
        },
        {
          img: require("@/assets/img/server.png"),
          title: "Servidores",
          slug: "server"
        },
      ],
    };
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.pause();
      }
    },
  },
  methods: {
    ready(event) {
      this.player = event.target;
    },
    playing(event) {
      // The player is playing a video.
    },
    change() {
      // when you change the value, the player will also change.
      // If you would like to change `playerVars`, please change it before you change `videoId`.
      // If `playerVars.autoplay` is 1, `loadVideoById` will be called.
      // If `playerVars.autoplay` is 0, `cueVideoById` will be called.
      this.videoId = "another video id";
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
    searchModels() {
      const searchUrl = `/certificados/busca/?search=${this.searchTerm}`;
      this.$router.push(searchUrl);
    }
  },
};
</script>
